<label class="switch" [class.disabled]="disabled">
    <input
        type="checkbox"
        [checked]="checked"
        [disabled]="disabled"
        (change)="toggle($event)"
    />

    <span
        class="slider round transition-colors duration-200"
        [ngClass]="checked ? 'bg-primary' : 'bg-gray-300'">
    </span>
</label>
